import React, { Component } from "react";
import * as router from "react-router-redux";
import { connect } from "react-redux";
import { actions } from "./redux";
import CSSModules from "react-css-modules";

import styles from "./styles.scss";
import DateTime from "../../../../utils/dateTime";
import { number, shouldUpdate } from "../../../../utils";
import moment from "moment";

let count = 0;
const idPrefix = "occurrencesTable";

@CSSModules(styles, { allowMultiple: true })
class OccurrencesTable extends Component {
	constructor(props) {
		super(props);
		this.props.initTable(this.props.id, this.props.component);
	}
	render() {
		if (!this.props.tableData) {
			return <div />;
		}
		return (
			<div styleName="component-wrapper">
				<div styleName="component-title">
					{this.props.component.chartTitle || "History 365"}</div>
				<table styleName="occurences-table">
					<thead>
						<tr>
							{this.props.tableData.headers.map((header, index) => (
								<th key={index} left={(index === 0 || index === 1).toString()} styleName="table-header">
									{header}
								</th>
							))}
						</tr>
					</thead>
					<tbody>
						{this.props.tableData.rows.map((row, index) => (
							<tr key={index}>
								<td left="true">{row.dateString}</td>
								<td left="true">{row.status}</td>
								{row.points.map((point, index2) => (
									<td key={index2}>
                                        {number.parseNumber(point.value, point.decimalPlaces)} {point.units}
									</td>
								))}
							</tr>
						))}
					</tbody>
				</table>
			</div>
		);
	}

	setup() {
		this.props.loadData(this.props.id, this.props.component, this.props.onLoadComplete);
	}

	componentDidMount() {
		this.setup();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevProps.tableData != this.props.tableData) {
			return true;
		} else if (prevProps.component != this.props.component) {
			this.setup();
			return false;
		} else {
			return false;
		}
	}
	shouldComponentUpdate(nextProps, nextState) {
		return shouldUpdate(this, nextProps, nextState, ["onLoadComplete"]);
	}
}

const bindAction = dispatch => {
	return {
		loadData: (id, component, onLoadComplete) => dispatch(actions.loadData(id, component, onLoadComplete)),
		initTable: (id, component) => dispatch(actions.initTable(id, component))
	};
};

const mapStateToProps = (state, ownProps) => ({
	tableData: state.occurrencestable.instances[ownProps.id]
});

//do this to merge classes
export default class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			wrapped: null
		};
		this.id = idPrefix + count;
		count++;
	}

	componentWillMount() {
		this.setState({
			wrapped: connect(
				mapStateToProps,
				bindAction
			)(OccurrencesTable)
		});
	}

	render() {
		const Elem = this.state.wrapped;

		return <Elem {...this.props} id={this.id} />;
	}
}



// WEBPACK FOOTER //
// ./src/components/ReportComponents/Tables/HistoryTable/HistoryTable.js